export const PageLinks = {
  home: "/",
  circle: "/h2facircular",
  designLab: "/design-lab",
  team: "/team",
  hydrogenForMobility: "/hydrogen-for-mobility",
  contactUs: "/contact-us",
  aboutUs: "/about-us",
};
